import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { MainService } from 'src/app/services/main.service'

import { FundManagement } from './fundManagement.model'

const contentIndex = 0
const profileIndex = 1

@Injectable({
  providedIn: 'root',
})
export class FundManagementService {
  fundManagementModel = {} as FundManagement
  fundManagementModel$: Observable<FundManagement>

  constructor(private readonly mainService: MainService) {}

  /*eslint complexity: [2, 10] */
  getModelData(): Observable<FundManagement> {
    return new Observable((subscriber) => {
      this.mainService
        .getFundManagementObservable()
        .pipe(take(1))
        .subscribe((ovObs) => {
          if (
            Object.keys(ovObs).length !== 0 &&
            ovObs[0]?.name !== 'HTTPError'
          ) {
            const contentPos = ovObs[contentIndex]
            const profPos = ovObs[profileIndex]?.fundProfile

            this.fundManagementModel = {
              investmentProcess: contentPos?.investmentProcess,
              firmAdvisor: contentPos?.firmAdvisor,
              advisor: contentPos?.advisor,
              is529: profPos?.is529,
              ticker: profPos?.ticker,
            }
          }
          subscriber.next(this.fundManagementModel)
          subscriber.complete()
        })
    })
  }
}
